// extracted by mini-css-extract-plugin
export default {"container":"sIz4V"};